/**
 * TanStack Query hooks for `igaming-audit-ready-logs`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	igamingAuditReadyLogsQueryKeys,
	type CreateIgamingAuditReadyLogsBody,
	type ListIgamingAuditReadyLogsResponse,
	type IgamingAuditReadyLogsRow,
} from "./api";

export function useIgamingAuditReadyLogsList(): UseQueryResult<ListIgamingAuditReadyLogsResponse, Error> {
	return useQuery({
		queryKey: igamingAuditReadyLogsQueryKeys.list(),
		queryFn: list,
	});
}

export function useIgamingAuditReadyLogsCreate(): UseMutationResult<IgamingAuditReadyLogsRow, Error, CreateIgamingAuditReadyLogsBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingAuditReadyLogsQueryKeys.all });
		},
	});
}

export function useIgamingAuditReadyLogsDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingAuditReadyLogsQueryKeys.all });
		},
	});
}
